import { ChangeDetectionStrategy, Component, effect, HostBinding, inject, input, PLATFORM_ID, signal } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { AppService } from '../../app.service';
import { ArtGalleryService } from '../gallery/art-gallery.service';
import { isPlatformBrowser } from '@angular/common';
import SliderComponent from '../../slider/slider.component';

@Component({
    selector: 'iea-art-board-viewer',
    templateUrl: './art-board-viewer.component.html',
    styleUrls: [`./art-board-viewer.component.scss`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SliderComponent],
    host: { class: 'app-container' },
    standalone: true,
})
export default class ArtBoardViewerComponent {
    private readonly router = inject(Router);
    private readonly ac = inject(ActivatedRoute);
    public readonly appService = inject(AppService);
    public readonly galleryService = inject(ArtGalleryService);

    activeArtBoardIndex = signal(null);
    content = input.required<any>();
    constructor() {
        effect(async () => {
            const artboard = this.content();
            if (!artboard) return;
            const idx = await this.galleryService.findIndexOrGetItemBySlug(artboard.slug);
            this.activeChange({ index: idx, artBoard: artboard });
        });
    }

    private readonly platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);
    images = [];

    async returnToList() {
        const category = this.galleryService.category;

        await this.router.navigate(['/gallery', category], {
            queryParams: this.galleryService.filter ? { filter: this.galleryService.filter } : {},
            relativeTo: this.ac,
            state: { board: this.activeArtBoard() },
        });
        this.galleryService.rerender();
    }

    activeArtBoard = signal(null);
    activeChange(event: { index: number; artBoard: any }) {
        const { index, artBoard } = event;
        if (index === undefined || index < 0) return;
        if (this.activeArtBoardIndex() === index) return;
        this.activeArtBoardIndex.set(index);
        if (index >= this.galleryService.all().length) return;

        const board = this.galleryService.all()[index];
        if (!board) throw new Error(`Art Board ${index} not found`);

        this.activeArtBoard.set(board);
        this.updateUrl(board);

        const diff = this.galleryService.all().length - index;
        if (diff <= 2 && this.galleryService.canGetMore) {
            this.galleryService.getNextPage();
        }
    }
    updateUrl(artBoard: any) {
        const { category, slug } = artBoard;
        this.router.navigate(
            ['/', category, 'canvas', slug].filter((s) => s),
            {
                queryParams: this.ac.snapshot.queryParams,
                relativeTo: this.ac,
                fragment: undefined,
            },
        );
    }
}
